/* Options:
Date: 2022-05-03 16:18:16
Version: 5.120
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44370

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/



export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export class driverPay_source
{
    public source_info: driverPay_sourceSource_info[];
    public org_id: number;
    public acct_type: string;
    public sequence: number;

    public constructor(init?: Partial<driverPay_source>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class driverPaymentinfo
{
    public status: string;
    public message: string;
    public payment_total: string;

    public constructor(init?: Partial<driverPaymentinfo>) { (Object as any).assign(this, init); }
}

export class driverContriboptions
{
    public status: string;
    public message: string;

    public constructor(init?: Partial<driverContriboptions>) { (Object as any).assign(this, init); }
}

// @Flags()
export enum CacheControl
{
    None = 0,
    Public = 1,
    Private = 2,
    MustRevalidate = 4,
    NoCache = 8,
    NoStore = 16,
    NoTransform = 32,
    ProxyRevalidate = 64,
}

export interface IContentTypeWriter
{
}

// @Flags()
export enum RequestAttributes
{
    None = 0,
    Localhost = 1,
    LocalSubnet = 2,
    External = 4,
    Secure = 8,
    InSecure = 16,
    AnySecurityMode = 24,
    HttpHead = 32,
    HttpGet = 64,
    HttpPost = 128,
    HttpPut = 256,
    HttpDelete = 512,
    HttpPatch = 1024,
    HttpOptions = 2048,
    HttpOther = 4096,
    AnyHttpMethod = 8160,
    OneWay = 8192,
    Reply = 16384,
    AnyCallStyle = 24576,
    Soap11 = 32768,
    Soap12 = 65536,
    Xml = 131072,
    Json = 262144,
    Jsv = 524288,
    ProtoBuf = 1048576,
    Csv = 2097152,
    Html = 4194304,
    Wire = 8388608,
    MsgPack = 16777216,
    FormatOther = 33554432,
    AnyFormat = 67076096,
    Http = 67108864,
    MessageQueue = 134217728,
    Tcp = 268435456,
    Grpc = 536870912,
    EndpointOther = 1073741824,
    AnyEndpoint = 2080374784,
    InProcess = -2147483648,
    InternalNetworkAccess = -2147483645,
    AnyNetworkAccessType = -2147483641,
    Any = -1,
}

export interface IRequestPreferences
{
    acceptsGzip: boolean;
    acceptsDeflate: boolean;
}

export class driverSummaryFile_exceptions
{
    public exception: driverSummaryFile_exceptionsException[];
    public total_exceptions: string;
    public total_warnings: string;

    public constructor(init?: Partial<driverSummaryFile_exceptions>) { (Object as any).assign(this, init); }
}

export class driverSummary
{
    public contribs: driverSummaryContrib[];
    public file_exceptions: driverSummaryFile_exceptions;
    public org_id: string;

    public constructor(init?: Partial<driverSummary>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol1
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol1>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol2
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol2>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol3
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol3>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol4
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol4>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol5
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol5>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol6
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol6>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol7
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol7>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol8
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol8>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol9
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol9>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol10
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol10>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol11
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol11>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol12
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol12>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol13
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol13>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol14
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol14>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol15
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol15>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol16
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol16>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol17
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol17>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headingsCol18
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailColumn_headingsCol18>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailColumn_headings
{
    public col1: driverCntb_detailColumn_headingsCol1;
    public col2: driverCntb_detailColumn_headingsCol2;
    public col3: driverCntb_detailColumn_headingsCol3;
    public col4: driverCntb_detailColumn_headingsCol4;
    public col5: driverCntb_detailColumn_headingsCol5;
    public col6: driverCntb_detailColumn_headingsCol6;
    public col7: driverCntb_detailColumn_headingsCol7;
    public col8: driverCntb_detailColumn_headingsCol8;
    public col9: driverCntb_detailColumn_headingsCol9;
    public col10: driverCntb_detailColumn_headingsCol10;
    public col11: driverCntb_detailColumn_headingsCol11;
    public col12: driverCntb_detailColumn_headingsCol12;
    public col13: driverCntb_detailColumn_headingsCol13;
    public col14: driverCntb_detailColumn_headingsCol14;
    public col15: driverCntb_detailColumn_headingsCol15;
    public col16: driverCntb_detailColumn_headingsCol16;
    public col17: driverCntb_detailColumn_headingsCol17;
    public col18: driverCntb_detailColumn_headingsCol18;

    public constructor(init?: Partial<driverCntb_detailColumn_headings>) { (Object as any).assign(this, init); }
}

export class driverCntb_detail
{
    public column_headings: driverCntb_detailColumn_headings;
    public part_details: driverCntb_detailPart_detail[];
    public cca_id: string;
    public recordcount: string;
    public payment_date: string;

    public constructor(init?: Partial<driverCntb_detail>) { (Object as any).assign(this, init); }
}

export class driverContributionOptions
{
    public org_id: number;
    public filetype: string;
    public scheduletype: string;
    public payrollname: string;
    public selected: string;

    public constructor(init?: Partial<driverContributionOptions>) { (Object as any).assign(this, init); }
}

export class driverAddEditResponse
{
    public msg_type: string;
    public msg: string;
    public cca_id: string;
    public plans: string;

    public constructor(init?: Partial<driverAddEditResponse>) { (Object as any).assign(this, init); }
}

export class driverCntb_history
{
    public files: driverCntb_historyFile[];
    public org_id: string;
    public org_type: string;
    public sched_type: string;

    public constructor(init?: Partial<driverCntb_history>) { (Object as any).assign(this, init); }
}

export class CmsFragment
{
    public name: string;
    public html: string;

    public constructor(init?: Partial<CmsFragment>) { (Object as any).assign(this, init); }
}

export class driverSufficientfunds
{
    public sufficientflag: string;
    public message: string;

    public constructor(init?: Partial<driverSufficientfunds>) { (Object as any).assign(this, init); }
}

export class driverHoliday
{
    public date: string;

    public constructor(init?: Partial<driverHoliday>) { (Object as any).assign(this, init); }
}

export interface IAuthTokens
{
    provider: string;
    userId: string;
    accessToken: string;
    accessTokenSecret: string;
    refreshToken: string;
    refreshTokenExpiry?: string;
    requestToken: string;
    requestTokenSecret: string;
    items: { [index: string]: string; };
}

// @DataContract
export class AuthUserSession
{
    // @DataMember(Order=1)
    public referrerUrl: string;

    // @DataMember(Order=2)
    public id: string;

    // @DataMember(Order=3)
    public userAuthId: string;

    // @DataMember(Order=4)
    public userAuthName: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public twitterUserId: string;

    // @DataMember(Order=7)
    public twitterScreenName: string;

    // @DataMember(Order=8)
    public facebookUserId: string;

    // @DataMember(Order=9)
    public facebookUserName: string;

    // @DataMember(Order=10)
    public firstName: string;

    // @DataMember(Order=11)
    public lastName: string;

    // @DataMember(Order=12)
    public displayName: string;

    // @DataMember(Order=13)
    public company: string;

    // @DataMember(Order=14)
    public email: string;

    // @DataMember(Order=15)
    public primaryEmail: string;

    // @DataMember(Order=16)
    public phoneNumber: string;

    // @DataMember(Order=17)
    public birthDate?: string;

    // @DataMember(Order=18)
    public birthDateRaw: string;

    // @DataMember(Order=19)
    public address: string;

    // @DataMember(Order=20)
    public address2: string;

    // @DataMember(Order=21)
    public city: string;

    // @DataMember(Order=22)
    public state: string;

    // @DataMember(Order=23)
    public country: string;

    // @DataMember(Order=24)
    public culture: string;

    // @DataMember(Order=25)
    public fullName: string;

    // @DataMember(Order=26)
    public gender: string;

    // @DataMember(Order=27)
    public language: string;

    // @DataMember(Order=28)
    public mailAddress: string;

    // @DataMember(Order=29)
    public nickname: string;

    // @DataMember(Order=30)
    public postalCode: string;

    // @DataMember(Order=31)
    public timeZone: string;

    // @DataMember(Order=32)
    public requestTokenSecret: string;

    // @DataMember(Order=33)
    public createdAt: string;

    // @DataMember(Order=34)
    public lastModified: string;

    // @DataMember(Order=35)
    public roles: string[];

    // @DataMember(Order=36)
    public permissions: string[];

    // @DataMember(Order=37)
    public isAuthenticated: boolean;

    // @DataMember(Order=38)
    public fromToken: boolean;

    // @DataMember(Order=39)
    public profileUrl: string;

    // @DataMember(Order=40)
    public sequence: string;

    // @DataMember(Order=41)
    public tag: number;

    // @DataMember(Order=42)
    public authProvider: string;

    // @DataMember(Order=43)
    public providerOAuthAccess: IAuthTokens[];

    // @DataMember(Order=44)
    public meta: { [index: string]: string; };

    // @DataMember(Order=45)
    public audiences: string[];

    // @DataMember(Order=46)
    public scopes: string[];

    // @DataMember(Order=47)
    public dns: string;

    // @DataMember(Order=48)
    public rsa: string;

    // @DataMember(Order=49)
    public sid: string;

    // @DataMember(Order=50)
    public hash: string;

    // @DataMember(Order=51)
    public homePhone: string;

    // @DataMember(Order=52)
    public mobilePhone: string;

    // @DataMember(Order=53)
    public webpage: string;

    // @DataMember(Order=54)
    public emailConfirmed?: boolean;

    // @DataMember(Order=55)
    public phoneNumberConfirmed?: boolean;

    // @DataMember(Order=56)
    public twoFactorEnabled?: boolean;

    // @DataMember(Order=57)
    public securityStamp: string;

    // @DataMember(Order=58)
    public type: string;

    public constructor(init?: Partial<AuthUserSession>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LoggingSession extends AuthUserSession
{
    // @DataMember
    public participantNumber: string;

    // @DataMember
    public sessionId: string;

    // @DataMember
    public ipAddress: string;

    // @DataMember
    public correlationId: string;

    public constructor(init?: Partial<LoggingSession>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class Institution
{
    // @DataMember
    public display: string;

    // @DataMember
    public value: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CurrentUser extends LoggingSession
{
    // @DataMember
    public activeInstitution: string;

    // @DataMember
    public institutions: Institution[];

    // @DataMember
    public isInternalUser: boolean;

    // @DataMember
    public hasAllInstitutions: boolean;

    // @DataMember
    public orgType: string;

    // @DataMember
    public domain: string;

    // @DataMember
    public xspSessionGuid: string;

    // @DataMember
    public xspUrl: string;

    // @DataMember
    public xspAuthToken: string;

    // @DataMember
    public xspContextToken: string;

    // @DataMember
    public starGenAPIURL: string;

    public constructor(init?: Partial<CurrentUser>) { super(init); (Object as any).assign(this, init); }
}

export class driverPay_sourceSource_info
{
    public id: number;
    public name: string;
    public value: string;

    public constructor(init?: Partial<driverPay_sourceSource_info>) { (Object as any).assign(this, init); }
}

export interface IHttpFile
{
    name: string;
    fileName: string;
    contentLength: number;
    contentType: string;
}

export class driverSummaryContrib
{
    public name: string;
    public value: string;

    public constructor(init?: Partial<driverSummaryContrib>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol1
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol1>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol2
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol2>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol3
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol3>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol4
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol4>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol5
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol5>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol6
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol6>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol7
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol7>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol8
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol8>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol9
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol9>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol10
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol10>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol11
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol11>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol12
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol12>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol13
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol13>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol14
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol14>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol15
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol15>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol16
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol16>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol17
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol17>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detailCol18
{
    public name: string;

    public constructor(init?: Partial<driverCntb_detailPart_detailCol18>) { (Object as any).assign(this, init); }
}

export class driverCntb_detailPart_detail
{
    public col1: driverCntb_detailPart_detailCol1;
    public col2: driverCntb_detailPart_detailCol2;
    public col3: driverCntb_detailPart_detailCol3;
    public col4: driverCntb_detailPart_detailCol4;
    public col5: driverCntb_detailPart_detailCol5;
    public col6: driverCntb_detailPart_detailCol6;
    public col7: driverCntb_detailPart_detailCol7;
    public col8: driverCntb_detailPart_detailCol8;
    public col9: driverCntb_detailPart_detailCol9;
    public col10: driverCntb_detailPart_detailCol10;
    public col11: driverCntb_detailPart_detailCol11;
    public col12: driverCntb_detailPart_detailCol12;
    public col13: driverCntb_detailPart_detailCol13;
    public col14: driverCntb_detailPart_detailCol14;
    public col15: driverCntb_detailPart_detailCol15;
    public col16: driverCntb_detailPart_detailCol16;
    public col17: driverCntb_detailPart_detailCol17;
    public col18: driverCntb_detailPart_detailCol18;
    public id: string;
    public ssn: string;
    public compensation: string;
    public effective_date: string;
    public exception_type: string;
    public message: string;
    public seqnum: string;
    public delete_link: string;

    public constructor(init?: Partial<driverCntb_detailPart_detail>) { (Object as any).assign(this, init); }
}

export class driverCntb_historyFile
{
    public id: string;
    public payroll_date: string;
    public status: string;
    public status_date: string;
    public total: string;
    public cca_id: string;
    public sched_date: string;

    public constructor(init?: Partial<driverCntb_historyFile>) { (Object as any).assign(this, init); }
}

export class driverSummaryFile_exceptionsException
{
    public type: string;
    public name: string;
    public count: string;

    public constructor(init?: Partial<driverSummaryFile_exceptionsException>) { (Object as any).assign(this, init); }
}

export class WespathLoggingFeature
{

    public constructor(init?: Partial<WespathLoggingFeature>) { (Object as any).assign(this, init); }
}

export class AccountResponse
{
    public pay_sources: driverPay_source[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AccountResponse>) { (Object as any).assign(this, init); }
}

export class RoutingServiceResponse
{
    public msg: string;
    public _continue: string;
    public success: string;

    public constructor(init?: Partial<RoutingServiceResponse>) { (Object as any).assign(this, init); }
}

export class UpdateBankAccountResponse
{
    public paymentinfo: driverPaymentinfo;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateBankAccountResponse>) { (Object as any).assign(this, init); }
}

export class UpdateContributionOptionResponse
{
    public contriboptions: driverContriboptions;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateContributionOptionResponse>) { (Object as any).assign(this, init); }
}

export class GetApplicationTimeoutResponse
{
    public logoffMinutes: number;
    public logoffWarningMinutes: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApplicationTimeoutResponse>) { (Object as any).assign(this, init); }
}

export class CMSummaryResponse
{
    public summary: driverSummary;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CMSummaryResponse>) { (Object as any).assign(this, init); }
}

export class CMDetailResponse
{
    public cntb_detail: driverCntb_detail;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CMDetailResponse>) { (Object as any).assign(this, init); }
}

export class CMOptionResponse
{
    public contributionOptions: driverContributionOptions;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CMOptionResponse>) { (Object as any).assign(this, init); }
}

export class NameBySSNUMCResponse
{
    public name: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<NameBySSNUMCResponse>) { (Object as any).assign(this, init); }
}

export class CMAddEditResponse
{
    public addEditResponse: driverAddEditResponse;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CMAddEditResponse>) { (Object as any).assign(this, init); }
}

export class SpireLicenseResponse
{
    public spirePDFKey: string;

    public constructor(init?: Partial<SpireLicenseResponse>) { (Object as any).assign(this, init); }
}

export class ChangeReportResponse
{
    public reportXML: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ChangeReportResponse>) { (Object as any).assign(this, init); }
}

export class ErrorHandlingResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ErrorHandlingResponse>) { (Object as any).assign(this, init); }
}

export class GetGoogleAnalyticsIdResponse
{
    public googleAnalyticsId: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetGoogleAnalyticsIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCMHistoryResponse
{
    public cntb_history: driverCntb_history;
    public dcrToken: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetCMHistoryResponse>) { (Object as any).assign(this, init); }
}

export class UploadFileResponse
{
    public ccaID: string;
    public payrollDate: string;
    public success: boolean;
    public messages: string[];
    public errors: string[];
    public contributionManagementHistory: GetCMHistoryResponse;

    public constructor(init?: Partial<UploadFileResponse>) { (Object as any).assign(this, init); }
}

export class UpdateActiveInstitutionResponse
{
    public institutionId: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateActiveInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetCmsFragmentResponse
{
    public fragment: CmsFragment;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetCmsFragmentResponse>) { (Object as any).assign(this, init); }
}

export class GetCmsFragmentCollectionResponse
{
    public fragments: CmsFragment[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetCmsFragmentCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CMWespathResponse
{
    public sufficientfunds: driverSufficientfunds;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CMWespathResponse>) { (Object as any).assign(this, init); }
}

export class GetCurrentTimeResponse
{
    public currentDateTime: string;

    public constructor(init?: Partial<GetCurrentTimeResponse>) { (Object as any).assign(this, init); }
}

export class PaymentUpdateResponse
{
    public paymentinfo: driverPaymentinfo;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PaymentUpdateResponse>) { (Object as any).assign(this, init); }
}

export class HolidayListResponse
{
    public holidays: driverHoliday[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<HolidayListResponse>) { (Object as any).assign(this, init); }
}

export class SelectedBankResponse
{
    public selected: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SelectedBankResponse>) { (Object as any).assign(this, init); }
}

export class AuthenticateUserResponse
{
    public user: CurrentUser;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AuthenticateUserResponse>) { (Object as any).assign(this, init); }
}

export class IsXSPSessionClosedResponse
{
    public sessionGuid: string;
    public sessionID: number;
    public lastActivity: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<IsXSPSessionClosedResponse>) { (Object as any).assign(this, init); }
}

export class UpdateSessionActivityResponse
{
    public isUpdateSessionActivityPerformed: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateSessionActivityResponse>) { (Object as any).assign(this, init); }
}

export class XspUrlResponse
{
    public url: string;

    public constructor(init?: Partial<XspUrlResponse>) { (Object as any).assign(this, init); }
}

// @Route("/GetBankAccount")
export class GetBankAccountName implements IReturn<AccountResponse>
{
    public umcID: string;

    public constructor(init?: Partial<GetBankAccountName>) { (Object as any).assign(this, init); }
    public createResponse() { return new AccountResponse(); }
    public getTypeName() { return 'GetBankAccountName'; }
}

// @Route("/ValidateRoutingNumber")
export class ValidateRoutingNumber implements IReturn<RoutingServiceResponse>
{
    public routingNumber: string;
    public accountNumber: string;
    public businessName: string;

    public constructor(init?: Partial<ValidateRoutingNumber>) { (Object as any).assign(this, init); }
    public createResponse() { return new RoutingServiceResponse(); }
    public getTypeName() { return 'ValidateRoutingNumber'; }
}

// @Route("/UpdateBankAccountInfo")
export class UpdateBankAccountInfo implements IReturn<UpdateBankAccountResponse>
{
    public tran: string;

    public constructor(init?: Partial<UpdateBankAccountInfo>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdateBankAccountResponse(); }
    public getTypeName() { return 'UpdateBankAccountInfo'; }
}

// @Route("/UpdateContributionOption")
export class UpdateContributionOption implements IReturn<UpdateContributionOptionResponse>
{
    public org_id: string;
    public scheduletype: string;
    public username: string;
    public account_sequence: string;
    public filetype: string;

    public constructor(init?: Partial<UpdateContributionOption>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdateContributionOptionResponse(); }
    public getTypeName() { return 'UpdateContributionOption'; }
}

export class GetApplicationTimeout implements IReturn<GetApplicationTimeoutResponse>
{

    public constructor(init?: Partial<GetApplicationTimeout>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetApplicationTimeoutResponse(); }
    public getTypeName() { return 'GetApplicationTimeout'; }
}

// @Route("/CMSummary")
export class CMSummary implements IReturn<CMSummaryResponse>
{
    public ccaId: string;

    public constructor(init?: Partial<CMSummary>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMSummaryResponse(); }
    public getTypeName() { return 'CMSummary'; }
}

// @Route("/CMDetail")
export class CMDetail implements IReturn<CMDetailResponse>
{
    public ccaId: string;
    public page: number;
    public rowsPerPage: number;
    public all: string;

    public constructor(init?: Partial<CMDetail>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMDetailResponse(); }
    public getTypeName() { return 'CMDetail'; }
}

// @Route("/CMOption")
export class CMOption implements IReturn<CMOptionResponse>
{
    public umcId: string;

    public constructor(init?: Partial<CMOption>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMOptionResponse(); }
    public getTypeName() { return 'CMOption'; }
}

// @Route("/NameBySSNUMC")
export class NameBySSNUMC implements IReturn<NameBySSNUMCResponse>
{
    public umcId: string;
    public ssn: string;

    public constructor(init?: Partial<NameBySSNUMC>) { (Object as any).assign(this, init); }
    public createResponse() { return new NameBySSNUMCResponse(); }
    public getTypeName() { return 'NameBySSNUMC'; }
}

// @Route("/CMAddEdit")
export class CMAddEdit implements IReturn<CMAddEditResponse>
{
    public tran: string;
    public fileType: string;

    public constructor(init?: Partial<CMAddEdit>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMAddEditResponse(); }
    public getTypeName() { return 'CMAddEdit'; }
}

// @Route("/CMDeleteRow")
export class CMDeleteRow implements IReturn<CMAddEditResponse>
{
    public tran: string;

    public constructor(init?: Partial<CMDeleteRow>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMAddEditResponse(); }
    public getTypeName() { return 'CMDeleteRow'; }
}

// @Route("/CMPDFDetail")
export class CMPDFDetail implements IReturn<CMDetailResponse>
{
    public ccaId: string;
    public recordCount: number;

    public constructor(init?: Partial<CMPDFDetail>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMDetailResponse(); }
    public getTypeName() { return 'CMPDFDetail'; }
}

// @Route("/GetSpireLicense")
export class GetSpireLicense implements IReturn<SpireLicenseResponse>
{

    public constructor(init?: Partial<GetSpireLicense>) { (Object as any).assign(this, init); }
    public createResponse() { return new SpireLicenseResponse(); }
    public getTypeName() { return 'GetSpireLicense'; }
}

// @Route("/ChangeReportRequest")
export class ChangeReportRequest implements IReturn<ChangeReportResponse>
{
    public ccaId: string;

    public constructor(init?: Partial<ChangeReportRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ChangeReportResponse(); }
    public getTypeName() { return 'ChangeReportRequest'; }
}

// @Route("/ErrorHandling")
export class ErrorHandling implements IReturn<ErrorHandlingResponse>
{
    public page: string;
    public message: string;

    public constructor(init?: Partial<ErrorHandling>) { (Object as any).assign(this, init); }
    public createResponse() { return new ErrorHandlingResponse(); }
    public getTypeName() { return 'ErrorHandling'; }
}

// @Route("/GetAnalyticsId")
export class GetGoogleAnalyticsId implements IReturn<GetGoogleAnalyticsIdResponse>
{

    public constructor(init?: Partial<GetGoogleAnalyticsId>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGoogleAnalyticsIdResponse(); }
    public getTypeName() { return 'GetGoogleAnalyticsId'; }
}

export class DCREmail implements IReturn<string>
{
    public formid: string;
    public umcid: string;
    public payrollDate: string;
    public processingDate: string;
    public finalPaymentAmount: number;
    public sendPaymentDate: string;
    public deliverByDate: string;
    public bankName: string;
    public accountName: string;
    public accountNumber: string;

    public constructor(init?: Partial<DCREmail>) { (Object as any).assign(this, init); }
    public createResponse() { return ''; }
    public getTypeName() { return 'DCREmail'; }
}

export class GetCMHistoryHelp implements IReturn<GetCMHistoryResponse>
{
    public umcId: string;

    public constructor(init?: Partial<GetCMHistoryHelp>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCMHistoryResponse(); }
    public getTypeName() { return 'GetCMHistoryHelp'; }
}

// @Route("/GetCMHistory")
export class GetCMHistory implements IReturn<GetCMHistoryResponse>
{
    public umcId: string;

    public constructor(init?: Partial<GetCMHistory>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCMHistoryResponse(); }
    public getTypeName() { return 'GetCMHistory'; }
}

// @Route("/CancelFile")
export class CancelFile implements IReturn<GetCMHistoryResponse>
{
    public ccaid: string;
    public isSendEmail: boolean;
    public umcId: string;

    public constructor(init?: Partial<CancelFile>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCMHistoryResponse(); }
    public getTypeName() { return 'CancelFile'; }
}

// @Route("/Upload")
export class Upload implements IReturn<UploadFileResponse>
{

    public constructor(init?: Partial<Upload>) { (Object as any).assign(this, init); }
    public createResponse() { return new UploadFileResponse(); }
    public getTypeName() { return 'Upload'; }
}

export class UpdateActiveInstitution implements IReturn<UpdateActiveInstitutionResponse>
{
    public institutionId: string;

    public constructor(init?: Partial<UpdateActiveInstitution>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdateActiveInstitutionResponse(); }
    public getTypeName() { return 'UpdateActiveInstitution'; }
}

export class GetCmsFragment implements IReturn<GetCmsFragmentResponse>
{
    public path: string;
    public alias: string;

    public constructor(init?: Partial<GetCmsFragment>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCmsFragmentResponse(); }
    public getTypeName() { return 'GetCmsFragment'; }
}

export class GetCmsFragmentCollection implements IReturn<GetCmsFragmentCollectionResponse>
{
    public path: string;
    public alias: string;

    public constructor(init?: Partial<GetCmsFragmentCollection>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCmsFragmentCollectionResponse(); }
    public getTypeName() { return 'GetCmsFragmentCollection'; }
}

// @Route("/CMWespath")
export class CMWespath implements IReturn<CMWespathResponse>
{
    public accountnumber: string;
    public debitamount: string;

    public constructor(init?: Partial<CMWespath>) { (Object as any).assign(this, init); }
    public createResponse() { return new CMWespathResponse(); }
    public getTypeName() { return 'CMWespath'; }
}

// @Route("/GetCurrentTime")
export class GetCurrentTime implements IReturn<GetCurrentTimeResponse>
{

    public constructor(init?: Partial<GetCurrentTime>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCurrentTimeResponse(); }
    public getTypeName() { return 'GetCurrentTime'; }
}

// @Route("/PaymentUpdate")
export class PaymentUpdate implements IReturn<PaymentUpdateResponse>
{
    public tran: string;
    public deliverbydt: string;

    public constructor(init?: Partial<PaymentUpdate>) { (Object as any).assign(this, init); }
    public createResponse() { return new PaymentUpdateResponse(); }
    public getTypeName() { return 'PaymentUpdate'; }
}

// @Route("/HolidayList")
export class HolidayList implements IReturn<HolidayListResponse>
{

    public constructor(init?: Partial<HolidayList>) { (Object as any).assign(this, init); }
    public createResponse() { return new HolidayListResponse(); }
    public getTypeName() { return 'HolidayList'; }
}

// @Route("/SelectedBank")
export class SelectedBank implements IReturn<SelectedBankResponse>
{
    public ccaid: string;

    public constructor(init?: Partial<SelectedBank>) { (Object as any).assign(this, init); }
    public createResponse() { return new SelectedBankResponse(); }
    public getTypeName() { return 'SelectedBank'; }
}

// @Route("/XSPSSO")
export class XSPSSO
{
    public token: string;
    public contextToken: string;
    public appType: string;
    public sessionId: string;
    public ipAddress: string;
    public localhostUrl: string;

    public constructor(init?: Partial<XSPSSO>) { (Object as any).assign(this, init); }
}

// @Route("/AuthenticateUser")
export class AuthenticateUser implements IReturn<AuthenticateUserResponse>
{

    public constructor(init?: Partial<AuthenticateUser>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateUserResponse(); }
    public getTypeName() { return 'AuthenticateUser'; }
}

// @Route("/IsXSPSessionClosed")
export class IsXSPSessionClosed implements IReturn<IsXSPSessionClosedResponse>
{

    public constructor(init?: Partial<IsXSPSessionClosed>) { (Object as any).assign(this, init); }
    public createResponse() { return new IsXSPSessionClosedResponse(); }
    public getTypeName() { return 'IsXSPSessionClosed'; }
}

// @Route("/UpdateSessionActivity")
export class UpdateSessionActivity implements IReturn<UpdateSessionActivityResponse>
{

    public constructor(init?: Partial<UpdateSessionActivity>) { (Object as any).assign(this, init); }
    public createResponse() { return new UpdateSessionActivityResponse(); }
    public getTypeName() { return 'UpdateSessionActivity'; }
}

// @Route("/DCRLogout")
export class DCRLogout implements IReturn<Object>
{

    public constructor(init?: Partial<DCRLogout>) { (Object as any).assign(this, init); }
    public createResponse() { return new Object(); }
    public getTypeName() { return 'DCRLogout'; }
}

// @Route("/XspUrl")
export class XspUrl implements IReturn<XspUrlResponse>
{

    public constructor(init?: Partial<XspUrl>) { (Object as any).assign(this, init); }
    public createResponse() { return new XspUrlResponse(); }
    public getTypeName() { return 'XspUrl'; }
}

